import JobDemo2Container from "../../components/home/jobDemo2";

const JobDemo2 = () => {
  return <JobDemo2Container />;
};

export default JobDemo2;
